let dirAudio = 'games/page034_game0/audio/';

let elements = {
  //pick: 3,
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page034_game0/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page034_game0/audio/false.mp3',
    // positive: 'games/page034_game0/audio/true.mp3',
    click: 'games/page034_game0/audio/click.mp3',
    icon: {
      on: 'games/page034_game0/img/audioOn.png',
      off: 'games/page034_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 48,
    height: 48,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 182,
    height: 180,
  },
  layoutItems: [
    {
      pos: {
        x: 232,
        y: 329,
      },
    },
    {
      pos: {
        x: 233,
        y: 832,
      },
    },
    {
      pos: {
        x: 1154,
        y: 581,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 750,
        y: -1,
      },
    },
    {
      pos: {
        x: 752,
        y: 193,
      },
    },
    {
      pos: {
        x: 750,
        y: -1 + 508,
      },
    },
    {
      pos: {
        x: 752,
        y: 193 + 508,
      },
    },
    {
      pos: {
        x: 1650,
        y: 259,
      },
    },
    {
      pos: {
        x: 1650,
        y: 439,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page034_game0/audio/44_pear.mp3',
          correct: {
            audioId: 'a01',
            image: {
              src: 'games/page034_game0/img/gr.webp',
            },
            width: 182,
            height: 180,
            correctItems: {
              images: [
                {
                  src: 'games/page034_game0/img/grok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 182,
                  height: 180,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a01',
            image: {
              src: 'games/page034_game0/img/pa.webp',
            },
            width: 182,
            height: 180,
            incorrectItems: {
              images: [
                {
                  src: 'games/page034_game0/img/pawr.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 182,
                  height: 180,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page034_game0/audio/49_tomato.mp3',
          correct: {
            audioId: 'a02',
            image: {
              src: 'games/page034_game0/img/po.webp',
            },
            width: 182,
            height: 180,
            correctItems: {
              images: [
                {
                  src: 'games/page034_game0/img/pook.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 182,
                  height: 180,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a02',
            image: {
              src: 'games/page034_game0/img/ma.webp',
            },
            width: 182,
            height: 180,
            incorrectItems: {
              images: [
                {
                  src: 'games/page034_game0/img/mawr.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 182,
                  height: 180,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page034_game0/audio/45_cherry.mp3',
          correct: {
            audioId: 'a03',
            image: {
              src: 'games/page034_game0/img/wi.webp',
            },
            width: 182,
            height: 180,
            correctItems: {
              images: [
                {
                  src: 'games/page034_game0/img/wiok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 182,
                  height: 180,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            audioId: 'a03',
            image: {
              src: 'games/page034_game0/img/cy.webp',
            },
            width: 182,
            height: 180,
            incorrectItems: {
              images: [
                {
                  src: 'games/page034_game0/img/cywr.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 182,
                  height: 180,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  mbAudioItemData: [
    {
      maskConfig: {
        click: { src: 'games/page034_game0/audio/click.mp3' },
        src: 'games/page034_game0/img/folia.webp',
        cssStyle: {
          width: 0,
          height: 0,
        },
      },
      id: 'a01',
      src: 'games/page034_game0/audio/44_pear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page034_game0/img/audioOn.png', iconOff: 'games/page034_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 0,
        x: 0,
      },
      unit: 'px',
      cssStyle: { width: 0, height: 0 },
    },
    {
      maskConfig: {
        click: { src: 'games/page034_game0/audio/click.mp3' },
        src: 'games/page034_game0/img/folia.webp',
        cssStyle: {
          width: 0,
          height: 0,
        },
      },
      id: 'a02',
      src: 'games/page034_game0/audio/49_tomato.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page034_game0/img/audioOn.png', iconOff: 'games/page034_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 0,
        x: 0,
      },
      unit: 'px',
      cssStyle: { width: 0, height: 0 },
    },
    {
      maskConfig: {
        click: { src: 'games/page034_game0/audio/click.mp3' },
        src: 'games/page034_game0/img/folia.webp',
        cssStyle: {
          width: 0,
          height: 0,
        },
      },
      id: 'a03',
      src: 'games/page034_game0/audio/45_cherry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page034_game0/img/audioOn.png', iconOff: 'games/page034_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 0,
        x: 0,
      },
      unit: 'px',
      cssStyle: { width: 0, height: 0 },
    },
  ],
  staticMaskConfig: [
    {
      id: 'a01',
      pos: {
        y: 195,
        x: 151,
      },
      unit: 'px',
      click: { src: dirAudio + 'click.mp3' },
      src: 'games/page034_game0/img/folia.webp',
    },
    {
      id: 'a02',
      pos: {
        y: 698,
        x: 152,
      },
      unit: 'px',
      click: { src: dirAudio + 'click.mp3' },
      src: 'games/page034_game0/img/folia.webp',
    },
    {
      id: 'a03',
      pos: {
        y: 447,
        x: 1073,
      },
      unit: 'px',
      click: { src: dirAudio + 'click.mp3' },
      src: 'games/page034_game0/img/folia.webp',
    },
  ],
  mbStaticAudioItemData: [
    {
      src: 'games/page034_game0/audio/44_pear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page034_game0/img/audioOn.png', iconOff: 'games/page034_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 330,
        x: 234,
      },
      unit: 'px',
    },
    {
      src: 'games/page034_game0/audio/49_tomato.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page034_game0/img/audioOn.png', iconOff: 'games/page034_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 833,
        x: 234,
      },
      unit: 'px',
    },
    {
      src: 'games/page034_game0/audio/45_cherry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page034_game0/img/audioOn.png', iconOff: 'games/page034_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 583,
        x: 1155,
      },
      unit: 'px',
    },
  ],
};

export default elements;
